import { atom } from 'jotai';

export const moreLikeThisAtom = atom(null);
